import { apiClient } from './api';
import type { AuditLog, AuditFilter, AuditStatistics } from '../types/auditLog';

export const auditService = {
  // Get audit logs with optional filtering
  getAuditLogs: async (filter?: AuditFilter): Promise<AuditLog[]> => {
    const params = new URLSearchParams();

    if (filter) {
      if (filter.actorId) params.append('actor_id', filter.actorId);
      if (filter.resourceType) params.append('resource_type', filter.resourceType);
      if (filter.resourceId) params.append('resource_id', filter.resourceId);
      if (filter.action) params.append('action', filter.action);
      if (filter.severity) params.append('severity', filter.severity);
      if (filter.startTime) params.append('start_time', filter.startTime);
      if (filter.endTime) params.append('end_time', filter.endTime);
      if (filter.limit !== undefined) params.append('limit', filter.limit.toString());
      if (filter.offset !== undefined) params.append('offset', filter.offset.toString());
    }

    const queryString = params.toString();
    const url = queryString ? `/admin/audit-logs?${queryString}` : '/admin/audit-logs';

    const response = await apiClient.get<AuditLog[]>(url);
    return response.data as AuditLog[];
  },

  // Get audit logs for a specific resource
  getAuditLogsByResource: async (resourceType: string, resourceId: string): Promise<AuditLog[]> => {
    const response = await apiClient.get<AuditLog[]>(
      `/admin/audit-logs/${resourceType}/${resourceId}`
    );
    return response.data as AuditLog[];
  },

  // Get audit logs by actor (user who performed the action)
  getAuditLogsByActor: async (
    actorId: string,
    limit?: number,
    offset?: number
  ): Promise<AuditLog[]> => {
    const params = new URLSearchParams();
    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());

    const queryString = params.toString();
    const url = queryString
      ? `/admin/audit-logs/actor/${actorId}?${queryString}`
      : `/admin/audit-logs/actor/${actorId}`;

    const response = await apiClient.get<AuditLog[]>(url);
    return response.data as AuditLog[];
  },

  // Get audit statistics
  getAuditStatistics: async (days?: number): Promise<AuditStatistics> => {
    const params = new URLSearchParams();
    if (days !== undefined) params.append('days', days.toString());

    const queryString = params.toString();
    const url = queryString
      ? `/admin/audit-logs/statistics?${queryString}`
      : '/admin/audit-logs/statistics';

    const response = await apiClient.get<AuditStatistics>(url);
    return response.data as AuditStatistics;
  },
};
